<template>
  <LayoutGridComponent
    :class="$style.root"
    data-break-early=""
  >
    <template
      v-for="(thumbnail, index) in thumbnails"
      :key="thumbnail.id"
    >
      <div
        v-if="includeGroupkey && yearIsNotCurrentYear(getStartYear(thumbnail)) && getStartYear(thumbnail) !== getStartYear(thumbnails[index - 1])"
        :class="$style.groupKey"
      >
        {{ getStartYear(thumbnail) }}
      </div>

      <SharedThumbnailProgramComponent
        :data="thumbnail"
        :class="$style.item"
        :forced-status="getStatus(thumbnail)"
        :data-status="getStatus(thumbnail)"
        :includeRelated="includeRelated"
      />
    </template>
  </LayoutGridComponent>
</template>

<script setup>
const props = defineProps({
  thumbnails: Array,
  includeRelated: {
    type: Boolean,
    default: true
  },
  includeGroupkey: {
    type: Boolean,
    default: false
  }
})

const getStatus = (thumbnail) => {
  if (!thumbnail) return null
  if (thumbnail?.attributes?.is_main_exhibition === true) {
    return 'inlineParent'
  }
  if (thumbnail?.attributes?.program_entries?.data?.length > 0) {
    return 'inlineParent'
  }
  return getItemProgramStatus(thumbnail)
}

const getStartYear = (thumbnail) => {
  if (!thumbnail) return null
  const startDate = thumbnail?.attributes?.date_time_start
  if (!startDate) return null
  return new Date(startDate).getFullYear()
}

const yearIsNotCurrentYear = (year) => {
  const currentYear = new Date().getFullYear()
  return year !== currentYear
}
</script>

<style module lang=scss>
.root {
  position: relative;

  padding-left: var(--unit--horizontal--tripple);
  padding-right: var(--unit--horizontal--tripple);

  grid-row-gap: calc(var(--unit--vertical--tripple) * 2);
}

.item[data-status="upcoming"],
.item[data-status="inlineParent"],
.item[data-status="current"] {
    grid-column: 1 / -1;
}

.item[data-status="past"] {
    grid-column: span 1;
}

.groupKey {
  grid-column: 1 / -1;

  composes: font-size-large from global;
  font-family: 'routed-gothic';

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit--spacer);
  margin: var(--unit--spacer) var(--unit--horizontal--double);
}
</style>
